import React from "react";
// import ScrollMagic from "scrollmagic";

class Videos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideVideoPlaceholder: false,
      iframeHide: true,
    };
    this.videoRef = React.createRef();
  }
  HandleVideoEvt = () => {
    const videoPlayerParent = document.getElementById(this.props.id);
    const videoPlayer = videoPlayerParent.querySelector("video");
    // Stop all players
    const trailer = document.getElementById("trailer");
    const trailerVideos = trailer.querySelectorAll(".swiper-slide video");
    // Pause all videos
    trailerVideos.forEach((video) => {
      if (!video.paused) {
        video.pause();
      }
    });
    if (videoPlayer) {
      // Play the clicked video
      videoPlayer.play();
      this.setState({ hideVideoPlaceholder: true });

      // Attach Scroll Video ONLY for Single Video
      //const ScrollController = new ScrollMagic.Controller();
      // const Scrolls = new ScrollMagic.Scene({
      //   triggerElement: `#${this.props.id} .ratio`,
      //   triggerHook: 0.7,
      //   duration: "100%",
      // }).addTo(ScrollController);
      // Scrolls.on("enter", function () {
      //   videoPlayer.play();
      // }).on("leave", function () {
      //   videoPlayer.pause();
      // });
    }
  };

  componentDidMount() {
    const trailer = document.getElementById("trailer");
    const trailerVideos = trailer.querySelectorAll(".swiper-slide video");
    // Pause all videos
    trailerVideos.forEach((video) => {
      if (!video.paused) {
        video.pause();
      }
    });
  }

  render() {
    return (
      <div id={this.props.id}>
        <div className="ratio ratio-16x9">
          {!this.state.hideVideoPlaceholder && (
            <div
              className="video-placeholder"
              onClick={this.HandleVideoEvt.bind(this)}
            >
              <img
                className="img-fluid w-100"
                src={require(`../assets/${this.props.image}`)}
                alt={this.props.title}
              />
              <div className="play-btn">
                <svg
                  className="img-fluid"
                  fill="#505a76"
                  width="800px"
                  height="800px"
                  viewBox="0 0 562.746 562.746"
                >
                  <path d="M281.37,0C125.977,0,0.003,125.974,0.003,281.373c0,155.399,125.974,281.373,281.373,281.373 c155.393,0,281.367-125.974,281.367-281.373C562.743,125.974,436.769,0,281.37,0z M484.212,305.425L192.287,471.986 c-23.28,13.287-42.154,2.326-42.154-24.479V115.239c0-26.805,18.874-37.766,42.154-24.479l291.925,166.562 C507.491,270.602,507.491,292.145,484.212,305.425z" />
                </svg>
              </div>
            </div>
          )}
          <video
            controls
            className={
              !this.state.hideVideoPlaceholder
                ? "opacity-0 main-player"
                : "main-player"
            }
            preload="auto"
            alt={this.props.title}
            src={this.props.url}
            type="video/mp4"
          />
        </div>
      </div>
    );
  }
}
export default Videos;
